window.DND_CAN={aspect:0.3301,profile:[[0.4809,0.999],[0.7408,0.9866],[0.8714,0.9741],[0.9053,0.9617],[0.9262,0.9493],[0.9508,0.9369],[0.9732,0.9245],[0.989,0.9121],[0.9967,0.8997],[0.9989,0.8873],[0.9992,0.8749],[0.9992,0.8625],[0.9993,0.8501],[0.9993,0.8376],[0.9995,0.8252],[0.9998,0.8128],[1,0.8004],[0.9998,0.788],[0.9994,0.7756],[0.9991,0.7632],[0.9993,0.7508],[0.9993,0.7384],[0.9993,0.726],[0.9993,0.7135],[0.9993,0.7011],[0.9993,0.6887],[0.9993,0.6763],[0.9993,0.6639],[0.9993,0.6515],[0.9993,0.6391],[0.9993,0.6267],[0.9993,0.6143],[0.9993,0.6019],[0.9993,0.5895],[0.9993,0.577],[0.9993,0.5646],[0.9993,0.5522],[0.9993,0.5398],[0.9993,0.5274],[0.9993,0.515],[0.9993,0.5026],[0.9993,0.4902],[0.9993,0.4778],[0.9993,0.4654],[0.9993,0.4529],[0.9993,0.4405],[0.9993,0.4281],[0.9993,0.4157],[0.9993,0.4033],[0.9993,0.3909],[0.9993,0.3785],[0.9993,0.3661],[0.9993,0.3537],[0.9993,0.3413],[0.9993,0.3289],[0.9993,0.3164],[0.9993,0.304],[0.9993,0.2916],[0.9993,0.2792],[0.9993,0.2668],[0.9993,0.2544],[0.9993,0.242],[0.9993,0.2296],[0.9993,0.2172],[0.9993,0.2048],[0.9993,0.1923],[0.9993,0.1799],[0.9993,0.1675],[0.9993,0.1551],[0.9991,0.1427],[0.9984,0.1303],[0.9972,0.1179],[0.9964,0.1055],[0.9962,0.0931],[0.9961,0.0807],[0.9946,0.0683],[0.9852,0.0558],[0.9589,0.0434],[0.9249,0.031],[0.8779,0.0186],[0.731,0.0062],[0.6215,0]]};
/* ============ DND content / data ============ */
window.DND = window.DND || {};
/* resource resolver: blob URL when bundled standalone, else the file path */
window.RES = (id, path) => (window.__resources && window.__resources[id]) || path;

window.DND.products = [
  {
    id:'still',
    name:'Still',
    full:'Still Water',
    accent:'#2d6cb2',
    theme:{ bg:'#f2f0ea', ink:'#16181b', sub:'#5a5f66' },
    img:window.RES('rotStill0r','assets/rot/still-0r.png'),
    canSide:window.RES('rotStill0r','assets/rot/still-0r.png'),
    turn:[window.RES('rotStill0r','assets/rot/still-0r.png'),window.RES('rotStill1f','assets/rot/still-1f.png'),window.RES('rotStill2f','assets/rot/still-2f.png')],
    tag:'Quiet hydration.',
    blurb:'Purified still water, pH-balanced and triple-filtered. Just water — nothing added, nothing loud, nothing you can taste.',
    price:1130, per:'12 × 330ml',
    perCan:99,
    packs:[{size:8,price:790},{size:12,price:1130},{size:24,price:2140}],
    badge:'Best seller',
    minerals:{ 'pH':'7.4', 'Sugar':'0 g', 'Energy':'0 kcal' }
  },
  {
    id:'sparkling',
    name:'Sparkling',
    full:'Sparkling Water',
    accent:'#b08a2e',
    theme:{ bg:'#121013', ink:'#f3efe6', sub:'#9b948c' },
    img:window.RES('rotSpark0r','assets/rot/spark-0r.png'),
    canSide:window.RES('rotSpark0r','assets/rot/spark-0r.png'),
    turn:[window.RES('rotSpark0r','assets/rot/spark-0r.png'),window.RES('rotSpark1','assets/rot/spark-1.png'),window.RES('rotSpark2','assets/rot/spark-2.png'),window.RES('rotSpark3','assets/rot/spark-3.png')],
    tag:'Bubbles. Elevated.',
    blurb:'Crisp, fine-bubble carbonation over the same clean mineral base. All the lift of a sparkling, none of the sugar or circus.',
    price:1250, per:'12 × 330ml',
    perCan:110,
    packs:[{size:8,price:880},{size:12,price:1250},{size:24,price:2380}],
    badge:'New',
    minerals:{ Carbonation:'Fine', Magnesium:'11mg', Potassium:'60mg' }
  },
  {
    id:'wellness',
    name:'Wellness',
    full:'Mineral + B12 Water',
    accent:'#2a57a8',
    theme:{ bg:'#d9dcdf', ink:'#16181b', sub:'#5a5f66' },
    img:window.RES('rotWell0r','assets/rot/well-0r.png'),
    canSide:window.RES('rotWell0r','assets/rot/well-0r.png'),
    turn:[window.RES('rotWell0r','assets/rot/well-0r.png'),window.RES('rotWell3','assets/rot/well-3.png'),window.RES('rotWell2','assets/rot/well-2.png')],
    tag:'Minerals. Balance. B12.',
    blurb:'Essential hydration, nothing extra — a heavier mineral load plus a clean dose of Vitamin B12. Steadier hydration and everyday energy. No sugar, no buzz, no crash.',
    price:1370, per:'12 × 330ml',
    perCan:120,
    packs:[{size:8,price:960},{size:12,price:1370},{size:24,price:2590}],
    badge:'',
    minerals:{ 'Vitamin B12':'2.4µg', Magnesium:'28mg', Silica:'30mg' }
  }
];

window.DND.nutritionBySku = {
  still:[
    ['Energy','0 kcal'],['Protein','0 g'],['Carbohydrate','0 g'],['Total Sugars','0 g'],
    ['Fat','0 g'],['Sodium','0 mg'],['pH','7.4']
  ],
  sparkling:[
    ['Energy','0 kcal'],['Carbonation','Fine bubble'],['Protein','0 g'],['Total Sugars','0 g'],
    ['Fat','0 g'],['Sodium','0 mg'],['Magnesium','11 mg'],['Potassium','60 mg'],['Silica','20 mg']
  ],
  wellness:[
    ['Energy','0 kcal'],['Vitamin B12','2.4 µg'],['Protein','0 g'],['Total Sugars','0 g'],
    ['Fat','0 g'],['Sodium','0 mg'],['Magnesium','28 mg'],['Potassium','75 mg'],['Silica','30 mg']
  ]
};
window.DND.nutrition = window.DND.nutritionBySku.still;

window.DND.assurances = [
  ['Microplastic tested','Every batch screened for micro- and nano-plastics before it reaches you.'],
  ['Purity verified','Lab-checked source water, triple-filtered to a spec we publish openly.'],
  ['Third-party tested','Independent labs sign off on every run. We don\u2019t mark our own homework.'],
  ['BPA-free & recyclable','Infinitely recyclable aluminium. No plastic, no liner, no compromise.']
];

window.DND.reviews = [
  ['It just gets out of the way. No taste, no plastic, no fuss — exactly what water should be.','Aisha R.','Still'],
  ['The black Sparkling can is the best-looking thing in my fridge. Bubbles are perfect — fine, not aggressive.','Marcus L.','Sparkling'],
  ['Wellness in the afternoon instead of a third coffee. Steadier, quieter, no crash.','Priya N.','Wellness'],
  ['The most premium-feeling water I\u2019ve put on a table. Guests always ask.','Daniel K.','Still'],
];

window.DND.faqs = [
  ['Why a can, not a bottle?','Aluminium is infinitely recyclable and keeps light and air off the water. No plastic ever touches what you drink — and the can chills faster and crushes flat.'],
  ['Is it really tasteless?','That\u2019s the point. We balance minerals so the water reads clean and neutral — quiet hydration, no aftertaste, no drama.'],
  ['What\u2019s the difference between the three?','Still is our everyday baseline. Sparkling adds crisp, fine-bubble carbonation. Wellness carries a heavier mineral load plus Vitamin B12 for everyday energy.'],
  ['Where do you ship?','We ship nationwide. Subscriptions arrive on your schedule and you can pause or cancel anytime.'],
];
